import { AmountsTableValue } from './AmountsTableValue';

export const sumAmountsTableValue = (value: AmountsTableValue): number => 
  value ? Object.values(value).reduce((a, b) => a + b, 0) : 0;
